$(document).ready(function(){
    
  $('.fancybox').each(function(){
    $(this).data('thumb', $(this).attr('href'));
  });
  $('.fancybox').fancybox({
    'afterClose':function() {
        $('.header-container').show();
      },
      'beforeShow':function(instance, current) {
        
        instance.current.opts.caption = $(instance.current.opts.$orig[0]).attr('title');
      },
      thumbs: {
        autoStart: true, // Display thumbnails on opening
        hideOnClose: true, // Hide thumbnail grid when closing animation starts
        parentEl: ".fancybox-container", // Container is injected into this element
        axis: "y" // Vertical (y) or horizontal (x) scrolling
      }
  });
  
  $('.slide-showvideo, .slide-showvideo-button, .mobile-landing .video .play')
    .on('click', function() {
      // $('#slider').easySliderStop();
    })
    .fancybox({
      width       : 960, 
      height      : 540,
      openEffect  : 'none',
      closeEffect : 'none',
      afterLoad   : function() {
       pSendGAEvent('pt_video_click', {'pt_video_id': 'explanation'}, 'integrations-2020.js', 'Video send event gone wrong'); 
      },
      media : {
        youtube : {
          params : {
            autoplay : 0
          }
        }
      }
    });
  
  $('.fancybox').on('click', function() {
     $('.header-container').hide();
  });
  
  $('.imageTextContainer img.clickable').on('click', function(){
    $(this).closest('.imageTextContainer').find('.buttonContainer a').trigger('click');
  });

});
